<template>
  <div class="team-member-circle-wrapper" :style="{ 'width': width || '45px', 'height': height || '45px' }" :class="{ 'active': isActive }">
    <span class="activity-indicator"></span>
    <span class="team-member-initials" :style="{ 'background-color': subject.profile_color, 'width': width || '45px', 'height': height || '45px' }">{{ initials }}</span>
    <img class="team-member-image" :style="{ 'width': width || '45px', 'height': height || '45px' }" :src="subject.photo_url" v-if="subject.photo_url">
  </div>
</template>

<script>
  export default {
    props: ['subject', 'width', 'height'],
    data() {
      return {
        isActive: false
      }
    },
    mounted() {
      var vm = this;
      var now = moment();
      var lastActive = vm.subject.last_active ? moment.utc(vm.subject.last_active) : false;

      if (lastActive && lastActive.isAfter(now.subtract(1000 * 60 * 5))) {
        vm.isActive = true;
      }
    },
    computed: {
      initials() {
        var vm = this;
        var matches = vm.subject.name.match(/\b(\w)/g);
        return matches.join('');
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "resources/assets/sass/layout/_variables";

  .team-member-circle-wrapper {
    position: relative;

    .team-member-image {
      position: absolute;
      border-radius: 100px;
      border: 1px solid $white;
    }

    .activity-indicator {
      display: block;
      position: absolute;
      width: 10px;
      height: 10px;
      top: 1px;
      left: 4px;
      background-color: $lightergrey;
      border-radius: 50%;
      border: 1px solid $white;
      z-index: 1;
    }

    .team-member-initials {
      position: absolute;
      border-radius: 100px;
      background: $mutedblue;
      color: $white;
      display: block;
      text-align: center;
      padding-top: 13px;
      border: 1px solid $white;
    }

    &.active {
      .activity-indicator {
        background-color: $green;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// team-member-avatar.vue?126a8588